import {Collection} from "../../collections/base";
import {BBModel} from "../../bb_model";
import {SlotCollections} from "../../collections/slot_collections";
import {TimeSlotModel} from "../core/time_slot";
import {bookingStatusCodes} from "../../constants/booking_status_codes";

const TWENTY_FOUR_HOURS_SECONDS = 86400;

class AdminSlotModel extends TimeSlotModel {

    constructor(data) {
        super(data);
        this.title = this.full_describe;

        if (this.date) {
            this.datetime = moment(this.date);
            this.start = this.datetime;
            this.end = this.start.clone().add(this.duration, 'days');
        } else {
            this.datetime = moment(this.datetime);
            this.start = this.datetime;
            this.end = moment(this.end_datetime);
        }

        this.time = (this.start.hour() * 60) + this.start.minute();
        this.title = this.full_describe;

        this.allDay = false;
        if (this.duration_span && (this.duration_span % TWENTY_FOUR_HOURS_SECONDS == 0)) {
            this.allDay = true;
            // pre and post time currntly not allowed in day based bookings
            this.pre_time = 0;
            this.post_time = 0;
        }

        if (this.status === AdminSlotModel.AVAILABLE) {
            this.title = 'Available';
            this.className = 'status_available';
        } else if (this.status === AdminSlotModel.BLOCKED) {
            this.startEditable = true;
            this.durationEditable = true;
            this.className = 'status_blocked';
        } else if (this.status === AdminSlotModel.BOOKED) {
            this.className = 'status_booked';
        } else if (this.status === AdminSlotModel.CREATED_EXTERNALLY) {
            this.className = 'status_external';
            this.type = 'external';
            this.editable = false;
            this.startEditable = false;
            this.durationEditable = false;
            this.resourceEditable = false;
        }

        if (this.current_multi_status) {
            this.className = `status_${this.current_multi_status}`;
        }


        if (this.num_spaces > 1 && !this.is_event){        
            this.is_multispace = true;
        }
    }


    useFullTime() {
        this.using_full_time = true;
        if (this.pre_time) {
            this.start = this.datetime.clone().subtract(this.pre_time, 'minutes');
        }
        if (this.post_time) {
            return this.end = this.datetime.clone().add(this.duration + this.post_time, 'minutes');
        }
    }


    $refetch() {
        return new Promise((resolve, reject) => {
            this.$flush('self');
            this.$get('self').then((res) => {
                    this.constructor(res);
                    if (this.using_full_time) {
                        this.useFullTime();
                    }
                    SlotSet.updateAll(this.$link('slot').href, this.company_id);
                    return resolve(this);
                }
                , err => reject(err));
        });
    }


    static $query(params) {
        let company;
        if (params.slot) {
            params.slot_id = params.slot.id;
        }
        if (params.date) {
            params.start_date = params.date;
            params.end_date = params.date;
        }
        if (params.company) {
            ({company} = params);
            delete params.company;
            params.company_id = company.id;
        }
        if (params.per_page == null) {
            params.per_page = 1024;
        }
        if (params.include_cancelled == null) {
            params.include_cancelled = false;
        }
        return new Promise((resolve, reject) => {
            const existing = SlotCollections.find(params);
            if (existing && !params.skip_cache) {
                resolve(existing);
            } else {
                let src = company;
                if (!src) {
                    ({src} = params);
                }
                if (params.src) {
                    delete params.src;
                }
                if (params.skip_cache) {
                    if (existing) {
                        SlotCollections.delete(existing);
                    }
                    src.$flush('slots', params);
                }

                src.$get('slots', params).then((resource) => {
                        if (resource.$has('slots')) {
                            return resource.$get('slots').then((slots) => {
                                    const models = (Array.from(slots).map(b => new BBModel.Admin.Slot(b)));
                                    const spaces = new Collection.Slot(resource, models, params);
                                    SlotCollections.add(spaces);
                                    return resolve(spaces);
                                }
                                , err => reject(err));
                        } else {
                            const slot = new BBModel.Admin.Slot(resource);
                            return resolve(slot);
                        }
                    }

                    , err => reject(err));
            }
        });
    }
}

Object.assign(AdminSlotModel, bookingStatusCodes);

export {
    AdminSlotModel
}
